<section class="modal-content modal-content-right">
  <button
    cjButton
    aria-label="Close"
    class="modal-close"
    tabIndex="-1"
    [disabled]="isProcessing"
    (click)="onClose()"
  >
    <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
  </button>

  <div class="flex flex-column" [style.height.%]="100">
    <div class="header-content p-6">    
      <h6>
        <cj-icon icon="credit-card" pack="font-awesome-solid" class="mr-2"></cj-icon>
        Update Card Details
      </h6>
    </div>

    <section class="body-content p-6 flex flex-column gap-3">
      <cj-form-field>
        <cj-form-label>Card Number</cj-form-label>
        <input
          cjInput
          fullWidth
          readonly
          type="text"
          tabIndex="-1"
          [value]="'**** **** **** ' + card.CardLast4Digits"
          [disabled]="isProcessing"
        />
      </cj-form-field>
      <div class="flex items-center gap-4">
        <cj-form-field class="flex-grow-1">
          <cj-form-label>Card Expiration</cj-form-label>
          <input
            cjInput
            fullWidth
            digitsOnly
            type="text"
            placeholder="MM/YYYY"
            tabIndex="1"
            maxlength="7"
            [disabled]="isProcessing"
            [ngModel]="cardExpiry"
            (keyup)="onKeyup($event)"
            (keydown)="onKeydown($event)"
          />
        </cj-form-field>
        <cj-form-field class="flex-grow-1">
          <cj-form-label>Card CVV</cj-form-label>
          <input
            cjInput
            fullWidth
            readonly
            type="text"
            tabIndex="-1"
            value="***"
            [disabled]="isProcessing"
          />
        </cj-form-field>
      </div>
      <cj-checkbox [disabled]="isProcessing" [(ngModel)]="card.IsDefault">
        Set as Default
      </cj-checkbox>
    </section>

    <div class="footer-content flex justify-end items-center gap-5 p-6">
      <span
        [style.cursor]="!isProcessing ? 'pointer' : 'default'" 
        (click)="!isProcessing ? onClose() : null">
        Discard
      </span>
      <button
        cjButton
        [disabled]="isProcessing"
        (click)="onSaveCard()">
        <span *ngIf="isProcessing" class="flex items-center mr-2">
          <cj-icon class="fa-spin" icon="spinner" pack="font-awesome-solid"></cj-icon>
        </span>
        <span *ngIf="!isProcessing" class="flex items-center mr-2">
          <cj-icon icon="save" pack="font-awesome-solid"></cj-icon>
        </span>
        {{ !isProcessing ? 'Update Card Details' : 'Updating Card Details...' }}
      </button>
    </div>
  </div>
</section>